import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { environment } from '@environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { MatStepper } from '@angular/material/stepper';

import { AuthenticationService, DependenteService, TemposRppsService } from '@app/shared/services';
import { CensoService } from '@app/shared/services/censo.service';
import { CookieService } from 'ngx-cookie-service';
import { MensagemService } from '@app/shared/services/mensagem.service';
import { RedirectService } from '@app/core/services/redirect.service';
import { SeguradoService } from '@app/shared/services/segurado.service';
import { UtilService } from '@app/shared/services/util.service';
import { ValidarRequiredFormService } from '@app/shared/services/validar-required-form.service';

import { Censo, ConfigCamposFormulario, Dependente, Loading, Segurado, TempoRPPS } from '@app/shared/models';

interface Etapas {
  [key: string]: ConfigCamposFormulario[];
}

@Component({
  selector: 'app-segundo-passo',
  templateUrl: './segundo-passo.component.html',
  styleUrls: ['./segundo-passo.component.scss']
})
export class SegundoPassoComponent{

  @ViewChild('stepper') stepper: MatStepper;

  autoAtendimento: any;
  carregar = new Loading();
  cliente = environment.cliente;
  mostrarListaDependentes: boolean = true;
  seguradoInformacoes: any = this.auth.currentUserValue;

  censo: Censo;
  segurado: Segurado;
  dependentes: Dependente[] = [];
  tempos: TempoRPPS[] = [];

  form: FormGroup;
  formEtapa1: FormGroup;
  formEtapa2: FormGroup;
  formEtapa3: FormGroup;
  formEtapa4: FormGroup;
  formEtapa5: FormGroup;
  formEtapa6: FormGroup;
  formEtapa7: FormGroup;

  buttons: any = null;

  configCamposFormulario: ConfigCamposFormulario[];
  configFormPorEtapa: Etapas = {
    'FORM_ETAPA_1': null, // camposDadosPessoais
    'FORM_ETAPA_2': null, // camposDocumentos
    'FORM_ETAPA_3': null, // camposEndereco
    'FORM_ETAPA_4': null, // camposContato
    'FORM_ETAPA_5': null, // camposDependentes
    'FORM_ETAPA_6': null, // camposDadosFuncionais
    'FORM_ETAPA_7': null, // camposTempos
  };

  etapasVisiveis = {
    etapa1: false,
    etapa2: false,
    etapa3: false,
    etapa4: false,
    etapa5: false,
    etapa6: false,
    etapa7: false // FORM SEPARADO
  };

  patchValueLoaded = false;

  constructor(
    private auth: AuthenticationService,
    private dependenteService: DependenteService,
    private cookieService: CookieService,
    private fb: FormBuilder,
    private mensagemService: MensagemService,
    private redirectService: RedirectService,
    private router: Router,
    private seguradoService: SeguradoService,
    private temposRppsService: TemposRppsService,
    private censoService: CensoService,
    private validarRequiredFormService: ValidarRequiredFormService,
    private utilService: UtilService,
    public dialog: MatDialog
  ) {
    this.censo = this.censoService.retornarSessionStorage('censo');
    this.moverParaURLCorreta();

    this.formEtapa1 = this.fb.group({
      id: [null],
      nome: [null, [Validators.minLength(6)]],
      nomeSocial: [null],
      nomeMae: [null, [Validators.minLength(6)]],
      nomePai: [null],
      estadoCivil: [null],
      dataNascimento: [null, [(control: AbstractControl) => this.utilService.validatorsCustomData(control)]],
      ufNaturalidadeId: [null],
      municipioId: [null],
      nacionalidadeId: [null],
      escolaridadeId: [null],
      sexo: [null],
      deficiente: [null],
      deficienteDescricao: [null],
      etnia: [null],
      formacao: [null],
    });

    this.formEtapa2 = this.fb.group({
      cpf: [null, [(control: AbstractControl) => this.utilService.validatorsCustomCPF(control)]],
      numeroRg: [null, Validators.maxLength(14)],
      orgaoEmissorRgId: [null],
      ufExpedicaoRgId: [null],
      dataEmissaoRg: [null, [(control: AbstractControl) => this.utilService.validatorsCustomData(control)]],
      nit: [null],
      numeroCtps: [null, [Validators.pattern('[0-9]*')]],
      dataEmissaoCtps: [null, [(control: AbstractControl) => this.utilService.validatorsCustomData(control)]],
      serieCtps: [null],
      numeroTituloEleitor: [null, Validators.maxLength(14)],
      zonaTituloEleitor: [null, Validators.maxLength(6)],
      secaoTituloEleitor: [null, Validators.maxLength(6)],
      ufExpedicaoTituloEleitorId: [null],
      certidao: [null, Validators.maxLength(15)],
      livro: [null, Validators.maxLength(10)],
      folha: [null, Validators.maxLength(5)],
    });

    this.formEtapa3 = this.fb.group({
      possuiEnderecoInternacional: [false],
      enderecoInternacional: [null],
      tipoLogradouroEndereco: [null],
      endereco: [null],
      numero: [null],
      ufEnderecoId: [null],
      municipioEnderecoId: [null],
      bairro: [null],
      cepEndereco: [null, [(control: AbstractControl) => this.utilService.validatorsCustomCEP(control), Validators.maxLength(9)]],
      complemento: [null],
    });

    this.formEtapa4 = this.fb.group({
      email: [null, []],
      contatoPrimario: [null, [Validators.minLength(10)]],
      contatoSecundario: [null, [Validators.minLength(10)]],
      descricaoContatoPrimario: [null],
      descricaoContatoSecundario: [null],
      contatoParaValidar: 'CONTATO_UM'
    });

    this.formEtapa5 = this.fb.group({

    });

    this.formEtapa6 = this.fb.group({
      orgao: [null],
      situacaoFuncional: [null],
      situacaoFuncionalOutro: [null],
      cargo: [null],
      secretaria: [null],
      lotacao: [null],
      matricula: [null],
      aposentadoria: [null],
      abonoPermanencia: [false],
      abonoPermanenciaData: [null, [(control: AbstractControl) => this.utilService.validatorsCustomData(control)]],
      previdenciaComplementar: [false],
      tetoRemuneratorio: [false],
      tetoRemuneratorioValor: [null]
    });

    this.formEtapa7 = this.fb.group({

    });

    this.buscarConfigCamposFormulario();
    this.buscarSegurado();
    this.buscarTipoSegurado();
    this.buscarTemposRGPS();
    this.buscarDependentes();
  }

  moverParaURLCorreta(): void {
    this.redirectService.verificarEtapa(this.carregar).subscribe(([status, etapa]) => {
      if (status.documentosRejeitados?.length > 0 || status.identificacoesRejeitadas?.length > 0) {
        if (status.identificacoesRejeitadas?.length > 0) {
          this.redirectService.redirecionar(true, null, true);
        } else {
          this.redirectService.redirecionar(true, null, false);
        }
      } else {
        this.redirectService.redirecionar(false, etapa);
      }
    });
  }

  buscarSegurado(): void {
    this.seguradoService.getSegurado(this.carregar).subscribe(segurado => {
      this.segurado = segurado;
      segurado.dataNascimento = this.utilService.formatarDataBR(segurado.dataNascimento);
      segurado.dataEmissaoCtps = this.utilService.formatarDataBR(segurado.dataEmissaoCtps);
      segurado.dataEmissaoRg = this.utilService.formatarDataBR(segurado.dataEmissaoRg);
      this.patchValue(segurado);
    })
  }

  buscarTipoSegurado(): void {
    this.seguradoService.buscarTipoSegurado(this.carregar).subscribe(tipo => this.mostrarListaDependentes = Boolean(tipo != "PENSIONISTA"));
  }

  buscarDependentes(): void {
    this.dependenteService.get(this.carregar).subscribe(dependentes => this.dependentes = dependentes);
  }

  buscarTemposRGPS(): void {
    this.temposRppsService.buscarTempos(this.carregar).subscribe(tempos => this.tempos = tempos);
  }

  buscarConfigCamposFormulario(): void {
    this.validarRequiredFormService.buscarConfiguracoesForm(this.cliente.censo_id, this.carregar).subscribe(config => {
      this.configCamposFormulario = config;
      this.filtrarDadosPorEtapaDaConfigCamposFormulario();
      this.definirValidatorRequiredNosCampos();
    })
  }

  filtrarDadosPorEtapaDaConfigCamposFormulario(): void {
    if (this.configCamposFormulario) {
      const etapas = [...new Set(this.configCamposFormulario.map(item => item.etapa))];

      etapas.forEach(etapa => {
        this.configFormPorEtapa[etapa] = this.configCamposFormulario.filter(item => item.etapa === etapa);
      });
    }
  }

  definirValidatorRequiredNosCampos(): void {
    const etapas = Object.keys(this.configFormPorEtapa);

    etapas.forEach((etapa, index) => {
      const formEtapa = this.formsEtapa[index];
      if (!formEtapa) {
        return;
      }

      this.validarRequiredFormService.definirValidatorRequiredNosCampos(
        formEtapa,
        this.configFormPorEtapa[etapa]
      );

      this.definirVisibilidadeDoStep(etapa);
    });
  }

  definirVisibilidadeDoStep(etapa: string): void {
    this.configFormPorEtapa[etapa].some(values => {
      if (values.visivel) {
        this.gerenciarStepsVisiveis(etapa)
      }
    })
  }

  gerenciarStepsVisiveis(etapa: string) {
    switch (etapa) {
      case 'FORM_ETAPA_1':
        this.etapasVisiveis.etapa1 = true;
        break;
      case 'FORM_ETAPA_2':
        this.etapasVisiveis.etapa2 = true;
        break;
      case 'FORM_ETAPA_3':
        this.etapasVisiveis.etapa3 = true;
        break;
      case 'FORM_ETAPA_4':
        this.etapasVisiveis.etapa4 = true;
        break;
      case 'FORM_ETAPA_5':
        this.etapasVisiveis.etapa5 = true;
        break;
      case 'FORM_ETAPA_6':
        this.etapasVisiveis.etapa6 = true;
        break;
      case 'FORM_ETAPA_7':
        this.etapasVisiveis.etapa7 = true;
        break;
    }
  }

  proximaEtapa(): void {
    if (!this.validarFormulario) return this.mensagemService.avisoFormularioInvalido();

    if (!this.validarEstadoCivil) return this.mensagemService.avisoMensagemAlerta('Por favor, adicione um dependente do tipo Cônjuge.');

    this.mensagemService.avisoMensagemCondicional(
      'Antes de seguir para a próxima etapa, você confirma que verificou as informações digitadas?',
      'Atenção',
      'warning'
    ).then((response) => {
      if (response.value) {
        this.salvarFormulario();
      }
    });
  }

  salvarFormulario(): void {
    this.seguradoService.putSegurado(this.formSalvar, this.carregar).subscribe(() => {
      this.router.navigate(['/recadastramento/terceiro-passo']);
    }, (error) => {
      this.mensagemService.avisoMensagemAlerta(
        'Por favor, verifique os campos obrigatórios e tente novamente.',
        'Erro ao salvar as informações'
      );
    });
  }

  logout(): void {
    this.mensagemService.avisoMensagemCondicional('', 'Você deseja realmente sair?', 'warning').then((response) => {
      if (response.value) {
        this.redirectService.buscarEtapa(this.carregar).subscribe(etapa => {
          if (etapa !== null && etapa !== 'ETAPA_1' && etapa !== 'ETAPA_2') {
            this.cookieService.deleteAll();
          }
          this.auth.logout();
          this.router.navigate(['/']);
        });
      }
    });
  }

  patchValue(segurado: Segurado) {
    this.formEtapa1.patchValue({
      ufNaturalidadeId: segurado.municipio?.uf?.id,
      municipioId: segurado.municipio?.id,
      nacionalidadeId: segurado.nacionalidade?.id,
      escolaridadeId: segurado.escolaridade?.id
    })

    this.formEtapa2.patchValue({
      orgaoEmissorRgId: segurado.orgaoEmissorRg?.id,
      ufExpedicaoRgId: segurado.ufExpedicaoRg?.id,
      ufExpedicaoTituloEleitorId: segurado.ufExpedicaoTituloEleitor?.id
    })

    this.formEtapa3.patchValue({
      ufEnderecoId: segurado.municipioEndereco?.uf?.id,
      municipioEnderecoId: segurado.municipioEndereco?.id
    })

    this.formsEtapa.forEach((formEtapa) => {
      formEtapa.patchValue(segurado);
    });

    this.patchValueLoaded = true;
  }

  get formsEtapa(): FormGroup[] {
    return [
      this.formEtapa1,
      this.formEtapa2,
      this.formEtapa3,
      this.formEtapa4,
      this.formEtapa5,
      this.formEtapa6,
      this.formEtapa7, // Garantir a ordem entre etape e valores de configuração
    ];
  }

  get formSalvar(): any {
    return {
      ...this.formEtapa1.value,
      ...this.formEtapa2.value,
      ...this.formEtapa3.value,
      ...this.formEtapa4.value,
      ...this.formEtapa6.value,
      dataNascimento: this.utilService.formatarDataPadraoHTML(this.formEtapa1.get('dataNascimento').value),
      dataEmissaoRg: this.utilService.formatarDataPadraoHTML(this.formEtapa2.get('dataEmissaoRg').value),
      dataEmissaoCtps: this.utilService.formatarDataPadraoHTML(this.formEtapa2.get('dataEmissaoCtps').value),
      abonoPermanenciaData: this.utilService.formatarDataPadraoHTML(this.formEtapa6.get('abonoPermanenciaData').value),
      dependentes: this.dependentes,
    };
  }

  get validarFormulario(): boolean {
    const arrayFormsInvalid: boolean[] = [];

    this.formsEtapa.forEach((formEtapa) => {
      arrayFormsInvalid.push(formEtapa.invalid)
    });

    const valid = arrayFormsInvalid.find(formInvalid => formInvalid === true) ? false : true

    if (valid && this.stepAtual == this.stepper?.steps?.length) {
      return true
    }

    return false
  }

  get stepAtual(): number {
    return (this.stepper == null) ? 1 : this.stepper.selectedIndex + 1;
  }

  get validarEstadoCivil(): boolean {
    if (this.censo.flagValidarEstadoCivil) {
      if (this.formSalvar.estadoCivil == 'CASADO' || this.formSalvar.estadoCivil == 'UNIAO_ESTAVEL') {

        const listaDependentesTipoConjuge = this.dependentes.filter(dependente => dependente.tipoDependencia.nome == 'CÔNJUGE').length;

        const listaDependentesTipoCompanheiro = this.dependentes.filter(dependente => dependente.tipoDependencia.nome == 'COMPANHEIRO(A)').length;

        if ((listaDependentesTipoConjuge + listaDependentesTipoCompanheiro) == 0) {
          return false
        }
      }
    }
    return true
  }

}
